import { ReactNode } from 'react'
import styles from '../assets/scss/components/layout.module.scss'

export const Layout: React.FC<{ children?: ReactNode }> = ({ children }) => {
  return <div className={styles.layout}>{children}</div>
}
